import List from "@/components/list";
import router from "@/router";
import Bus from "./Bus.js";

const Table = (args) => {
  const RCSelectionChange = args.listeners["selection-change"] || function() {};

  function handleDelete({ row }) {
    Bus.$emit("deleteAudioSet", row);
  }

  function handleUpdate({ row }) {
    router.push({
      path: "/audioSet/edit",
      query: {
        uuid: row.uuid,
      },
    });
  }

  function shareManage(id) {
    Bus.$emit("shareManage", id);
  }

  function upLine({ row }) {
    Bus.$emit("upLine", row);
  }

  function downLine({ row }) {
    Bus.$emit("downLine", row);
  }

  const Deal = ({ props: { vo } }) => {
    const audioSet = vo.row;
    const canOnline = audioSet.onlineStatus == 0;
    const canOffline = audioSet.onlineStatus == 1;
    const canNotEdit = audioSet.enableShared == 0 || audioSet.onlineStatus == 1;
    const dealConf = [
      [
        canNotEdit ? "icon-edit-disable" : "icon-edit",
        "编辑",
        canNotEdit ? () => {} : () => handleUpdate(vo),
        "audioSet:update",
      ],
      [
        canOnline ? "icon-delete" : "icon-delete-disable",
        "删除",
        canOnline ? () => handleDelete(vo) : () => {},
        "audioSet:delete",
      ],
    ];

    if (canOffline) {
      dealConf.push([
        "icon-down",
        "下线",
        () => downLine(vo),
        "audioSet:online",
      ]);
    } else if (canOnline) {
      dealConf.push(["icon-up", "上线", () => upLine(vo), "audioSet:online"]);
    }

    if (audioSet.enableShared) {
      dealConf.push([
        "icon-share",
        "共享管理",
        () => shareManage(audioSet.uuid),
        "audioSet:sharePage",
      ]);
    } else {
      dealConf.push([
        "icon-share-none",
        "共享管理",
        () => {},
        "audioSet:sharePage",
      ]);
    }
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const SyncSetAuthor = ({ props: { vo } }) => {
    return <span>{vo.row.syncSetAuthor || "--"}</span>;
  };
  const SyncSetReciter = ({ props: { vo } }) => {
    return <span>{vo.row.syncSetReciter || "--"}</span>;
  };
  const FormDeptName = ({ props: { vo } }) => {
    return <span>{vo.row.formDeptName || "--"}</span>;
  };
  const ShareDeptName = ({ props: { vo } }) => {
    return <span>{vo.row.shareDeptName || "--"}</span>;
  };

  const AudioName = ({ props: { vo } }) => {
    return (
      <div
        class="base-hover-char"
        onClick={() => {
          let uuid = vo.row.uuid;
            if (vo.row.parentId != null && vo.row.parentId != "") {
              uuid = vo.row.parentId;
            }
            router.push({
              path: "/audioSet/details",
              query: { id: uuid },
            });
        }}
      >
        {vo.row.audioSetName}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      type: "selection",
      label: "main",
    },
    {
      label: "音频集名称",
      prop: "audioSetName",
      minWidth: "200",
      fixed: "left",
      render: (vo) => <AudioName vo={vo} />,
    },
    {
      label: "作者",
      prop: "syncSetAuthor",
      render: (vo) => <SyncSetAuthor vo={vo} />,
      minWidth: "80",
    },
    {
      label: "朗诵者",
      prop: "syncSetReciter",
      render: (vo) => <SyncSetReciter vo={vo} />,
      minWidth: "80",
    },
    {
      label: "音频分类",
      prop: "categoryName",
      minWidth: "90",
    },
    {
      label: "音频数",
      prop: "audioInfoNum",
      width: "70",
    },
    {
      label: "状态",
      prop: "onlineStatusName",
      minWidth: "70",
    },
    {
      label: "版权方",
      prop: "formDeptName",
      minWidth: "100",
      render: (vo) => <FormDeptName vo={vo} />,
      showOverflowTooltip: true,
    },
    {
      label: "已共享学院名称",
      prop: "shareDeptName",
      minWidth: "150",
      render: (vo) => <ShareDeptName vo={vo} />,
      showOverflowTooltip: true,
    },
    {
      label: "创建时间",
      prop: "createDate",
      width: "150",
      showOverflowTooltip: true,
    },
    {
      label: "操作",
      width: "130",
      fixed: "right",
      render: (vo) => <Deal vo={vo} />,
    },
  ];
  return (
    <div>
      <List
        {...args}
        onSelectionChange={RCSelectionChange}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
